import StatusBadge from "~/components/StatusBadge";

type Props = {
	isBookable: boolean;
	showTimeTrackingInfo?: boolean;
};

const QuotaStatusBadge = ({ isBookable, showTimeTrackingInfo = true }: Props) => {
	let text = isBookable ? "Aktiv" : "Inaktiv";

	if (showTimeTrackingInfo) {
		text += isBookable ? " (Zeiterfassung möglich)" : " (Zeiterfassung nicht möglich)";
	}

	return <StatusBadge theme={isBookable ? "success" : "danger"}>{text}</StatusBadge>;
};

export default QuotaStatusBadge;